import { formatAmount } from './formatAmount';

export const calculateLoanPoints =
  (loanPointsPercentage: number, loanAmount: number): number =>
    parseFloat(formatAmount((loanPointsPercentage * loanAmount) / 100)) || 0;
